import type {
  ColorValue,
  GestureResponderEvent,
  StyleProp,
  TextStyle,
  ViewStyle
} from 'react-native';
import { View } from 'react-native';

import {
  SegmentedButtonItem,
  type SegmentButtonTheme
} from '@/shared/components/segmented-button/SegmentedButtonItem';

export type SegmentedButton<T extends string> = {
  value: T;
  label?: string;
  style?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
  rippleStyle?: StyleProp<ViewStyle>;
  rippleColor?: ColorValue;
  testID?: string;
  onPress?: (event: GestureResponderEvent) => void;
};

export type SegmentedButtonsProps<T extends string> = {
  value: T;
  onValueChange: (value: T) => void;
  buttons: SegmentedButton<T>[];
  rippleStyle?: StyleProp<ViewStyle>;
  style?: StyleProp<ViewStyle>;
  theme?: SegmentButtonTheme;
};

export const SegmentedButtons = <T extends string>({
  value,
  onValueChange,
  buttons,
  rippleStyle,
  style,
  theme
}: SegmentedButtonsProps<T>) => (
  <View style={[{ flexDirection: 'row' }, style]}>
    {buttons.map((item, index) => {
      let segment: 'first' | 'last' | undefined;
      if (index === 0) {
        segment = 'first';
      } else if (index === buttons.length - 1) {
        segment = 'last';
      }

      const onPress = (event: GestureResponderEvent) => {
        item.onPress?.(event);
        onValueChange(item.value);
      };

      return (
        <SegmentedButtonItem
          key={item.value}
          checked={value === item.value}
          label={item.label}
          onPress={onPress}
          segment={segment}
          style={item.style}
          labelStyle={item.labelStyle}
          rippleStyle={[rippleStyle, item.rippleStyle]}
          rippleColor={item.rippleColor}
          testID={item.testID}
          theme={theme}
        />
      );
    })}
  </View>
);
